import { gql } from '@apollo/client'

export default gql`
    mutation sendCustomPush($userid: String!, $message: String!, $navigation: String!) {
        sendCustomPush(userid: $userid, message: $message, navigation: $navigation)
    }
`
